/// <amd-module name="Analytics/Shared/QueryBuilder" />
import { FilterExpression } from "./FilterExpression";

export class ODataQuery {

    public get orderby(): string {
        return this._orderBy;
    }

    public get apply(): string {
        return this._apply;
    }
    private _orderBy = "";
    private _apply = "";
    private _expectAggregateAfterGroupBy: boolean;

    public filter(filterExpression: FilterExpression | string): ODataQuery {
        if (filterExpression) {
            this.throwIfAggregateExpected();
            if (this.apply) {
                this._apply += " / ";
            }

            if (filterExpression instanceof FilterExpression) {
                this._apply += `filter(${filterExpression.toString()})`;
            } else {
                this._apply += `filter(${filterExpression})`;
            }
        }

        return this;
    }

    public groupBy(...attributes: string[]): ODataQuery {
        if (attributes && attributes.length > 0) {
            this.throwIfAggregateExpected();
            if (this.apply) {
                this._apply += " / ";
            }

            this._apply += `groupby((${attributes.join(",")})`;
            this._expectAggregateAfterGroupBy = true;
        }
        return this;
    }

    public aggregate(...expressions: string[]): ODataQuery {
        if (expressions && expressions.length > 0) {
            const aggregate = `aggregate(${expressions.join(",")})`;
            if (this._expectAggregateAfterGroupBy) {
                // Aggregate followed by groupby
                this._apply += `, ${aggregate})`;
                this._expectAggregateAfterGroupBy = false;
            } else {
                if (this._apply) {
                    this._apply += " / ";
                }

                this._apply += aggregate;
            }
        }

        return this;
    }

    public orderBy(attribute: string, order: "asc" | "desc"): ODataQuery {
        if (attribute) {
            this.throwIfAggregateExpected();
            this._orderBy = `${attribute} ${order}`;
        }

        return this;
    }

    public compute(expressions: string): ODataQuery {
        if (expressions && expressions.length > 0) {
            const compute = `compute(${expressions})`;
            if (this._apply) {
                this._apply += " / ";
            }

            this._apply += compute;
        }

        return this;
    }

    private throwIfAggregateExpected(): void {
        if (this._expectAggregateAfterGroupBy) {
            throw new Error(`aggregate is expected after group by. Sub query: ${this._apply}`);
        }
    }
}
